import type { ReactNode } from "react";
import { Flex } from "@chakra-ui/react";
import { OrdersNewPageHeader } from "./OrdersNewPageHeader";

/**
 * Base layout.
 */
export const OrdersNewPageBaseLayout = ({
	children,
}: {
	children: ReactNode | string;
}) => {
	return (
		<Flex direction="column" h="100vh" w="100vw">
			{/* HEADER */}
			<OrdersNewPageHeader />
			{/* BODY */}
			<Flex flexGrow={1} justifyContent="center" py={6} px={4}>
				{children}
			</Flex>
		</Flex>
	);
};
